import { Outlet } from 'react-router';
import { ConnectionBanner } from '@/components/ConnectionBanner';
import { BottomNav, SideNav, SkipLink } from './nav';
import type { NavItem } from './nav';
import { StaffHeader } from './StaffHeader';

export const STAFF_NAV: NavItem[] = [
  { to: '/staff', label: 'Floor', icon: 'floor', end: true },
  { to: '/staff/ready', label: 'Ready', icon: 'check' },
  { to: '/staff/requests', label: 'Requests', icon: 'bell' },
  { to: '/staff/menu', label: 'Menu', icon: 'menu' },
];

/** Waiter shell: dark header, bottom tabs on phones, a left rail from tablet width, canvas workspace. */
export function StaffShell({ children }: { children?: React.ReactNode }) {
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <SkipLink />
      <StaffHeader title="Waiter" />
      <ConnectionBanner />
      <div className="flex flex-1">
        <aside className="hidden w-56 shrink-0 border-r border-line bg-white p-3 md:block">
          <SideNav items={STAFF_NAV} label="Staff" />
        </aside>
        <main id="main" tabIndex={-1} className="min-w-0 flex-1 px-4 pt-4 pb-6 md:px-6">
          {children ?? <Outlet />}
        </main>
      </div>
      <div className="md:hidden">
        <BottomNav items={STAFF_NAV} label="Staff mobile" />
      </div>
    </div>
  );
}
